<template>
    <button 
        :disabled="disabled || saving" 
        :size="size"
        fill="clear"
        class="h-10 font-medium uppercase tracking-wide text-sm rounded-xl border-2 border-white text-white w-full mx-4 transition-all duration-200 hover:opacity-60"
        :class="{ 'opacity-50 cursor-not-allowed': disabled || saving }"
    >
        <fa-icon 
            v-if="saving"
            :icon="['far', 'spinner-third']" 
            size="2x" 
            spin
        ></fa-icon>
        <span
            v-if="!saving"
        >{{message}}</span>
    </button>
</template>

<script setup lang="ts">

const props = defineProps({
    message: {
        type: String,
        default: 'Please wait...',
    },
    size:{
        type: String,
        default: 'default',
    },
    disabled:{
        type: Boolean,
        default: false,
    },
    saving:{
        type: Boolean,
        default: false,
    },
})
</script>
